import { Subscribe } from "../../domain/subscribe/subscribeEntity";
import * as actionTypes from "./subscribeActionTypes";

const updateSubscribeAction = (subscribe: Subscribe) => (dispatch: any) =>
    dispatch({ type: actionTypes.UPDATE_SUBSCRIBE, subscribe })

const updateNewsletterAction = (newsletter: Subscribe) => (dispatch: any) =>
dispatch({ type: actionTypes.UPDATE_NEWSLETTER, newsletter })

export { updateSubscribeAction, updateNewsletterAction };